import { AnimatePresence, motion, useReducedMotion } from 'motion/react'

const PHASE_MESSAGES: string[] = [
  'Securely uploading your document...',
  'Sending to AI processing engine...',
  'Reading document structure...',
  'Extracting company information...',
  'Verifying extracted data...',
  'Preparing your form...',
]

interface PhaseMessagesProps {
  currentPhase: number  // 0-5
}

export function PhaseMessages({ currentPhase }: PhaseMessagesProps) {
  const reducedMotion = useReducedMotion()
  const message = PHASE_MESSAGES[currentPhase] ?? PHASE_MESSAGES[0]

  return (
    <div
      style={{
        position: 'relative',
        minHeight: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <AnimatePresence mode="wait">
        <motion.p
          key={currentPhase}
          initial={reducedMotion ? {} : { opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={reducedMotion ? {} : { opacity: 0 }}
          transition={reducedMotion ? { duration: 0 } : { duration: 0.25, ease: 'easeInOut' }}
          style={{
            margin: 0,
            fontFamily: 'var(--font-body)',
            fontSize: 'var(--text-label-lg)',
            fontWeight: 'var(--weight-medium)',
            color: 'var(--color-text-primary)',
            textAlign: 'center',
            lineHeight: 'var(--leading-normal)',
          }}
          aria-live="polite"
          aria-atomic="true"
        >
          {message}
        </motion.p>
      </AnimatePresence>
    </div>
  )
}
